// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';

import modal from '../ui/modal';
import {
    closeModal,
    getRegisterFields,
    setForm,
    setLanguage,
    logoutUser,
} from '../actions';
import { getSelectedAsset } from '../selectors/assets';
import Header from '../ui/components/Modal/Header';
import Footer from '../ui/components/Modal/Footer';
import Notification from '../middleware/notifications/components/Notification';

import {
    LOGIN_FORM,
    PRICE_OPTS_FORM,
    MY_ACCOUNT_FORM,
} from './../constants/forms';
import { makeForm } from './Forms';

type Props = {
    modal: Object,
    auth: {
        isAuthenticated: boolean,
    },
    asset: Object,
    isVisible: boolean,
    closeModal: Function,
    setForm: Function,
    getRegisterFields: Function,
    language: String,
    branding: {
        paywall_primary_color: string,
    },
    form: string,
    setLanguage: Function,

    logoutUser: Function,
    options: {
        footerLinks: Array<Object>,
        hideFooterLinks: boolean,
        hideProtectedBy: boolean,
    },
};

type State = {
    isVisible: boolean,
};

export class Modal extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            isVisible: false,
        };
    }

    componentDidMount() {
        const { auth, asset, modal } = this.props;

        this.props.getRegisterFields();

        if (auth.isAuthenticated) {
            if (
                (auth.user && auth.user.completed) ||
                (auth.user.metadata && auth.user.metadata.register_source)
            ) {
                if (asset.hasAccess && modal.form === '') {
                    this.props.closeModal();
                } else {
                    //@todo - close modal on standalone paywall (only login/register).
                    if (modal.form === '') this.props.setForm(PRICE_OPTS_FORM);
                }
            } else {
                this.props.setForm(MY_ACCOUNT_FORM);
            }
        } else {
            if (modal.form === '') this.props.setForm(LOGIN_FORM);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        if (
            nextProps.auth.isAuthenticated &&
            nextProps.asset.hasAccess &&
            nextProps.modal.form === ''
        ) {
            this.props.closeModal();
        } else if (
            this.props.auth.isAuthenticated &&
            !nextProps.auth.isAuthenticated
        ) {
            this.props.setForm(LOGIN_FORM);
        }
    }

    handleMoreClick = () =>
        this.setState(({ isVisible }) => ({ isVisible: !isVisible }));

    changeForm = (form: any) => this.props.setForm(form);

    render() {
        const {
            auth,
            language,
            branding,
            form,
            options,
            setLanguage,
            logoutUser,
            closeModal,
        } = this.props;

        return (
            <div className="inplayer-paywall">
                <Header onClose={closeModal} />
                <div>
                    <Notification noPortal={true} />
                    {makeForm(form)}
                </div>
                <Footer
                    isAuthenticated={auth.isAuthenticated}
                    isVisible={this.state.isVisible}
                    changeForm={this.changeForm}
                    handleMoreClick={this.handleMoreClick}
                    language={language}
                    branding={branding}
                    form={form}
                    options={options}
                    setLanguage={setLanguage}
                    logoutUser={logoutUser}
                />
            </div>
        );
    }
}

const dialog = modal({
    name: 'inplayer-modal',
    style: {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(7,34,55,0.85)',
        },
        content: {
            position: 'relative',
            borderRadius: '2px',
            overflow: 'hidden',
            margin: '5vh auto',
            background: '#f0f3f6',
            boxShadow: '0 1px 8px 0 rgba(0,0,0,0.4)',
            padding: '0px',
            maxWidth: '375px',
            minWidth: '160px',
            WebkitBoxSizing: 'border-box',
            MozBoxSizing: 'border-box',
            boxSizing: 'border-box',
        },
    },
})(Modal);

const mapStateToProps = (state: Object) => {
    return {
        asset: getSelectedAsset(state),
        modal: state.modal,
        auth: state.auth,
        isVisible: state.isVisible,
        language: state.auth.language,
        branding: state.branding,
        form: state.modal.form,
        options: state.paywall.options,
    };
};

export default connect(
    mapStateToProps,
    {
        closeModal,
        getRegisterFields,
        setForm,
        setLanguage,
        logoutUser,
    }
)(dialog);



// WEBPACK FOOTER //
// ./src/containers/Modal.js